/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import {useNavigate} from 'react-router-dom';
import Btn from '@corero/ssp-ui-components/components/buttons/BlueButton/BlueButton';
import Helmet from "react-helmet";
import './NotFound.scss';

import logo from "../../assets/images/404-image.png";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <Helmet defer={false} title="Not Found" />
      <div className="row">
        <div className="col-sm-4 col-sm-offset-4 border">
          <div className="login-inner-container">
            <div className="row">
              <div className="col-sm-8 col-sm-offset-2 text-center border">
                <img alt="" src={logo} />
              </div>
            </div>
            <div className="row mt90">
              <div className="col-sm-12 text-center border">
                <h3>The page you are looking for cannot be found</h3>
                <p className="mt10">Go back to the home page</p>
                <Btn click={navigate.bind(this, '/overview')} title="Back to Home page" className="mt70"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
